<span [hidden]="!visible">
  <span class="d-flex clock-countdown justify-content-end">
    <span>{{'layout.header.countdown.label' | translate | uppercase}}</span>
    <span class="text-end" style="width: 4.5rem">{{count | timeParse:'S':'MINUTES_SECONDS' }}</span>
  </span>
</span>